import React from 'react';
import TableCell from 'components/organisms/Tables/Table/TableCell';

const TableEdit = (props) => {
  return <TableCell {...props} edit={true}/>
};

export default TableEdit;
